import { GatsbyBrowser } from 'gatsby';

let hasLoaded = false;

const munchkinFunctionActivation = () => {
  if (window.Munchkin && window.Munchkin.munchkinFunction) {
    window.Munchkin.munchkinFunction('visitWebPage', {
      url: window.location.pathname,
    });
  }
};

const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const munchkin = document.createElement('script');
  munchkin.src = 'https://munchkin.marketo.net/munchkin.js';
  munchkin.async = true;
  munchkin.onload = () => {
    window.Munchkin?.init('805-PTZ-019');
    munchkinFunctionActivation();
    hasLoaded = true;
  };

  document.body.appendChild(munchkin);
};

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  // Munchkin isn't made for SPA so we must mimic what it
  // does on landing after any route changes which is to
  // log the visited page and log any clicked links
  if (hasLoaded) {
    munchkinFunctionActivation();
  }
};

export { onInitialClientRender, onRouteUpdate };
